import React from 'react';
import { Container, ContentContainer, IconContainer, Title, TopContainer } from './styles';

export default function BaseSection({ Icon, title, children}) {
  return (
    <Container>
      <TopContainer>
        <IconContainer>
          {Icon}
        </IconContainer>
        <Title>{title}</Title>
      </TopContainer>
      <ContentContainer>
        {children}
      </ContentContainer>
    </Container>
  );
}